
const useData = () => {
const data = [
    {
        id: "1",
        img: "https://i.ibb.co/MPWSXL2/1.png",
        name: "Tools-Zone (MERN)",
        technology: "MongoDb, express Js, React Js, Node Js, Tailwind, Firebase Authentication",
        liveLink: "https://assignment-12-f3512.web.app/",
        img1: "https://i.ibb.co/QdczmX9/image-2022-12-24-T06-27-28-705-Z.png",
        img2: "https://i.ibb.co/RH2qQS8/image-2022-12-24-T06-32-52-530-Z.png",
        img3: "https://i.ibb.co/MgxShDx/image-2022-12-24-T06-35-34-254-Z.png",
        cilent: "https://github.com/mousumiaktar/tools-zone-client-side",
        server: "https://github.com/mousumiaktar/tools-zone-server-side",
        detail1: "MERN-Stack application.",
        detail2: "User can registration and login with google",
        detail3: "Can make purchase with desired products",
        detail4: "Admin can manage all orders, users, products, can add new product and also can make a new admin"
        
    },
    {
        id: "2",
        img: "https://i.ibb.co/yn4vqVc/2.png",
        name: "Furniture-Mart (MERN)",
        technology: "MongoDb, express Js, React Js, Node Js, Bootstrap, Firebase Authentication",
        liveLink: "https://fashion-mart-6b696.web.app/",
        img1: "https://i.ibb.co/q0Nn2bJ/281867239-489671839580801-5423722562211212493-n.png",
        img2: "https://i.ibb.co/8Djrp0x/283272715-392805926203343-1458832412368017319-n.png",
        img3: "https://i.ibb.co/2Fp0r0K/281352536-550752029915658-7169634698294917057-n.png",
        cilent: "https://github.com/mousumiaktar/furniture-mart-client-side",
        server: "https://github.com/mousumiaktar/furniture-mart-server-side",
        detail1: "MMERN-Stack application.",
        detail2: "User can registration and login with google",
        detail3: "Can make stock and deliver with desired product and see his/her orders in the order page",
        detail4: "Admin can manage all products, add new products"
    },
    {
        id: "3",
        img: "https://i.ibb.co/HgKfSNV/3.png",
        name: "Photo-Hunter",
        technology: "Bootstrap, React Js, Firebase Authentication",
        liveLink: "https://wedding-photography-faa30.web.app/",
        img1: "https://i.ibb.co/1JMtmSC/280859343-353226676902267-6954150766656310136-n.png",
        img2: "https://i.ibb.co/bdphW22/286052631-559043742510645-6742026857087023547-n.png",
        img3: "https://i.ibb.co/YtR5S7H/280761154-1397924074021575-8581811811236814587-n.png",
        cilent: "https://github.com/mousumiaktar/phone-hunter",
        detail1: "It is an independent influencer site.",
        detail2: "User can registration and login with google",
        detail3: "Can book desired service",
        detail4: "Designed by React Bootstrap"
    }
];
    
  return data  
    
};


export default useData;